import Vue from "vue";
import Vuex from "vuex";

import User from "@/store/module/user";
import Equipoplogs from "@/store/module/equipoplogs";
import Workorders from "@/store/module/workorders";
import Bill from "@/store/module/bill";
import Setting from "@/store/module/setting";
import Message from "@/store/module/message";
import Train from "@/store/module/train";
import Users from "@/store/module/users";
import Wechatdown from "@/store/module/wechatdown";
import Stadium from "@/store/module/stadium";
import Finance from "@/store/module/finance";
import Apprelease from "@/store/module/apprelease";
import Api from "@/store/module/api";
import Statistics from "@/store/module/statistics";
import Agreement from "@/store/module/agreement";
import Projects from "@/store/module/projects";
import Wechatnotify from "@/store/module/wechatnotify";
import Invitecode from "@/store/module/invitecode";
import Club from "@/store/module/club";
import Allstadiums from "@/store/module/allstadiums";
import Payments from "@/store/module/payments";
import Help from "@/store/module/help";
import Oplatformapps from "@/store/module/oplatformapps";
import Track from "@/store/module/track";
import LoginAuthIgnore from "@/store/module/loginauthignore";
import Wechat from "@/store/module/wechat";
import Syslog from "@/store/module/syslog";
import Operationlogs from "@/store/module/operationlogs";
import Adserver from "@/store/module/adserver";
import Customer from "@/store/module/customer";
import Sms from "@/store/module/sms";
import Appmodules from "@/store/module/appmodules";
import Shorturl from "@/store/module/shorturl";
import Wxamplink from "@/store/module/wxamplink";

import GroupPerception from "@/store/module/group_perception";
import GroupXiaoyu from "@/store/module/group_xiaoyu";
import Announcement from "@/store/module/announcement";
import EnterApply from "@/store/module/enterapply";
import Poster from "@/store/module/poster";
import Precisionmarketing from "@/store/module/precisionmarketing";
import Sensitive from "@/store/module/sensitive";

import Equipment from "@/store/module/equipment";

import Datav from "@/store/module/datav";
import Tel from "@/store/module/tel";
import Powerfailure from "@/store/module/powerfailure";
import Options from "@/store/module/options";
import Robots from "@/store/module/robots";
import Dmarketing from "@/store/module/dmarketing";
import Notification from "@/store/module/notification";
import Cos from "@/store/module/cos";
import Admin from "@/store/module/admin";
import PrivateTel from "@/store/module/privatetel";
import Blocklist from "@/store/module/blocklist";
import Redpacket from "@/store/module/redpacket";
import Article from "@/store/module/article";
import ArticleCate from "@/store/module/article_cate";
import SpecialOperation from "@/store/module/special_operation";
import Footprint from "@/store/module/footprint";
import ProductFeatures from "@/store/module/product_features";
import WireBill from "@/store/module/wire_bill";
import Products from "@/store/module/products";
import Bi from "@/store/module/bi";
import Shutdowns from "@/store/module/shutdowns";

import Bom from "@/store/module/bom";
import Bp from "@/store/module/bp";
import Stadiumcrm from "@/store/module/stadiumcrm";
import Invest from "@/store/module/invest";
import InvestAudit from "@/store/module/invest_audit";
import InvestTeam from "@/store/module/invest_team";
import StadiumEstimate from "@/store/module/stadium_estimate";
import StadiumCooperate from "@/store/module/stadium_cooperate";
import InvestLog from "@/store/module/invest_log";
import InvestCorrect from "@/store/module/invest_correct"
import Investigate from "@/store/module/investigate"

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    breadcrumbs: [],
    unReadMsgNum: 0,
    unReadMsgList: [],
    gUserId: 0,
    gUserDetailModalVisible: false,
    gBillId: 0,
    gBillDetailModalVisible: false,
    gConfirmModalVisible: false,
    gLineChartModalVisible: false,
    gLineChartParams: {},
    gConfirmModalParams: {},
    gOperationReason: "",
    gPagination: {},
    gListDispatchType: "",
    gSetBg: ""
  },
  mutations: {
    saveBreadcrumbs(state, payload) {
      state.breadcrumbs = payload;
      state.gSetBg = "";
    },
    saveGPagination(state, payload) {
      state.gPagination = payload;
    },
    saveGDispatchType(state, payload) {
      state.gListDispatchType = payload;
    },
    refreshUnReadMsgNum(state, payload) {
      state.unReadMsgNum = payload;
    },
    refreshUnReadMsgList(state, payload) {
      state.unReadMsgList = payload;
    },
    showUserDetailModal(state, payload) {
      state.gUserId = payload;
      state.gUserDetailModalVisible = true;
    },
    hideUserDetailModal(state, payload) {
      state.gUserDetailModalVisible = false;
    },
    showBillDetailModal(state, payload) {
      state.gBillId = payload;
      state.gBillDetailModalVisible = true;
    },
    hideBillDetailModal(state, payload) {
      state.gBillDetailModalVisible = false;
    },
    showLineChartModal(state, payload) {
      state.gLineChartParams = payload;
      state.gLineChartModalVisible = true;
    },
    hideLineChartModal(state, payload) {
      state.gLineChartModalVisible = false;
    },
    showConfirmModal(state, payload) {
      state.gOperationReason = "";
      state.gConfirmModalParams = payload;
      state.gConfirmModalVisible = true;
    },
    hideConfirmModal(state, payload) {
      state.gOperationReason = "";
      state.gConfirmModalVisible = false;
    },
    saveOperationReason(state, payload) {
      // console.log(payload)
      state.gOperationReason = payload;
    },
    setBg(state, payload) {
      state.gSetBg = payload;
    }
  },
  actions: {
    setBreadcrumbs({ commit, dispatch }, params) {
      dispatch("notification/categories", {}).then((res: any) => {
        if (res && res.Data) {
          let unReadMsgNum = 0;
          for (const obj of res.Data) {
            unReadMsgNum += Number(obj.ccount);
          }
          commit("refreshUnReadMsgNum", unReadMsgNum);
          commit("refreshUnReadMsgList", res.Data);
        }
      });
      commit("saveBreadcrumbs", params);
    },
    setGPagination({ commit, dispatch }, params) {
      commit("saveGPagination", params);
    },
    setGDispatchType({ commit, dispatch }, params) {
      commit("saveGDispatchType", params);
    },
    flushLocalUserInfo({ commit }) {
      window.localStorage.removeItem("token");
      commit("user/removeToken");
    },
    async refreshToken({ commit, dispatch }, params) {
      return dispatch("user/refreshToken");
    },
    showUserDetailModal({ commit, dispatch }, params) {
      commit("showUserDetailModal", params);
    },
    hideUserDetailModal({ commit, dispatch }, params) {
      commit("hideUserDetailModal", params);
    },
    showBillDetailModal({ commit, dispatch }, params) {
      commit("showBillDetailModal", params);
    },
    hideBillDetailModal({ commit, dispatch }, params) {
      commit("hideBillDetailModal", params);
    },
    showLineChartModal({ commit, dispatch }, params) {
      commit("showLineChartModal", params);
    },
    hideLineChartModal({ commit, dispatch }, params) {
      commit("hideLineChartModal", params);
    },
    showConfirmModal({ commit, dispatch }, params) {
      commit("showConfirmModal", params);
    },
    hideConfirmModal({ commit, dispatch }, params) {
      commit("hideConfirmModal", params);
    },
    saveOperationReason({ commit, dispatch }, params) {
      commit("saveOperationReason", params);
    },
    setBg({ commit, dispatch }, params) {
      commit("setBg", params);
    }
  },
  modules: {
    user              : User,
    equipoplogs       : Equipoplogs,
    workorders        : Workorders,
    bill              : Bill,
    setting           : Setting,
    message           : Message,
    train             : Train,
    users             : Users,
    wechatdown        : Wechatdown,
    stadium           : Stadium,
    finance           : Finance,
    apprelease        : Apprelease,
    api               : Api,
    statistics        : Statistics,
    agreement         : Agreement,
    projects          : Projects,
    wechatnotify      : Wechatnotify,
    invitecode        : Invitecode,
    club              : Club,
    allstadiums       : Allstadiums,
    payments          : Payments,
    help              : Help,
    oplatformapps     : Oplatformapps,
    track             : Track,
    loginauthignore   : LoginAuthIgnore,
    wechat            : Wechat,
    syslog            : Syslog,
    operationlogs     : Operationlogs,
    adserver          : Adserver,
    customer          : Customer,
    sms               : Sms,
    appmodules        : Appmodules,
    shorturl          : Shorturl,
    wxamplink         : Wxamplink,
    groupPerception   : GroupPerception,
    groupXiaoyu       : GroupXiaoyu,
    announcement      : Announcement,
    enterapply        : EnterApply,
    poster            : Poster,
    precisionmarketing: Precisionmarketing,
    sensitive         : Sensitive,
    datav             : Datav,
    equipment         : Equipment,
    tel               : Tel,
    powerfailure      : Powerfailure,
    options           : Options,
    robots            : Robots,
    dmarketing        : Dmarketing,
    notification      : Notification,
    cos               : Cos,
    admin             : Admin,
    privatetel        : PrivateTel,
    blocklist         : Blocklist,
    redpacket         : Redpacket,
    article           : Article,
    articleCate       : ArticleCate,
    specialOperation  : SpecialOperation,
    footprint         : Footprint,
    productfeatures   : ProductFeatures,
    wirebill          : WireBill,
    products          : Products,
    bi                : Bi,
    shutdowns         : Shutdowns,
    bom               : Bom,
    bp                : Bp,
    stadiumcrm        : Stadiumcrm,
    invest            : Invest,
    invest_team       : InvestTeam,
    stadium_estimate  : StadiumEstimate,
    stadium_cooperate : StadiumCooperate,
    invest_log        : InvestLog,
    invest_audit      : InvestAudit,
    invest_correct    : InvestCorrect,
    investigate       : Investigate
  }
});
